import { Link } from "react-router-dom";

import {
  TARGET_CONFIRM_HREF,
  TARGET_CONFIRM_LINE,
  TARGET_CONFIRM_LINK_LABEL,
} from "../../lib/target-confirm";

/**
 * Plan 454 M5 (task:target-unresolved-state). The ONE render of the
 * "your target has no resolved ZIP" state. A buyer whose active target was
 * saved before target_zip existed (no backfill, decision 569) has no
 * geography claim to launch-check, so every marketplace surface shows this
 * single line instead of a not-live message, a waitlist card, or a Join
 * button. Browse and `/offers` mount the component; Home's `no_target` hero
 * reads the same copy and href from `lib/target-confirm`.
 */

export function TargetConfirmLine({
  testId = "target-confirm-line",
}: {
  testId?: string;
}) {
  return (
    <div className="marketplace-surface p-6 text-center" data-testid={testId}>
      <p className="text-base font-semibold text-foreground">
        {TARGET_CONFIRM_LINE}
      </p>
      <Link
        className="mt-4 inline-flex min-h-11 items-center justify-center rounded-full border border-border bg-popover px-5 text-sm font-semibold text-foreground transition-colors hover:bg-muted"
        data-testid="target-confirm-link"
        to={TARGET_CONFIRM_HREF}
      >
        {TARGET_CONFIRM_LINK_LABEL}
      </Link>
    </div>
  );
}
